<template>
   <fragment>
      <TopNav />
      <main role="main" class="container feedback">
         <div v-if="!feedbackSent">
            <h1>Send us your feedback!</h1>
            <div class="row">
               <div class="col-lg-12">
                  <form method="get" class="feedback-form">
                     <div class="form-group">
                        <label for="feedbackMessage">Your message:</label>
                        <textarea
                           class="form-control col-lg-6"
                           id="feedbackMessage"
                           rows="5"
                           v-model="bodyText"
                           placeholder="Add your suggestion or describe your issue here."
                        ></textarea>
                     </div>
                     <!-- site key needs to come from a env var (was 6Lc0oC8eAAAAAOJpEFlAvHODXz0l-fq3DD2fqZVg)-->
                     <vue-recaptcha
                        class="mb-2"
                        :sitekey="siteKey"
                        @verify="didVerify"
                        @expired="tokenExpired"
                     >
                     </vue-recaptcha>
                     <button
                        :disabled="!isVerified"
                        class="btn btn-sm btn-dark my-2 my-sm-0"
                        type="button"
                        @click="onSubmit"
                     >
                        Send Feedback
                     </button>
                  </form>
                  <div v-if="tooSoon">
                     <p class="warning">
                        You need to wait for at least 1 minute since you last sent feedback.
                     </p>
                  </div>
               </div>
            </div>
         </div>
         <div v-else>
            <h1>Thank you!</h1>
            <div class="row">
               <div class="col-lg-12">
                  <p>Thank you for your message.</p>
                  <p></p>
               </div>
            </div>
         </div>
      </main>
   </fragment>
</template>

<script>
import TopNav from '@/components/TopNav';
import {VueRecaptcha} from 'vue-recaptcha';

export default {
   name: 'Feedback',
   components: {
      TopNav,
      VueRecaptcha,
   },
   data: function () {
      return {
         bodyText: '',
         feedbackSent: false,
         lastTimeSent: 0,
         tooSoon: false,
         verifyToken: false,
         siteKey: process.env.SITE_KEY,
      };
   },
   computed: {
      isVerified() {
         return this.verifyToken;
      },
   },
   mounted() {
      if (localStorage.lastTimeSent) {
         this.lastTimeSent = localStorage.lastTimeSent;
      }
      this.verifyToken = false;
      // console.log('SiteKey: ', process.env.SITE_KEY);
      // console.log('data sitekey: ', this.siteKey);
   },
   methods: {
      tokenExpired: function () {
         console.log('token expired!');
         this.verifyToken = false;
      },
      didVerify: function (response) {
         // console.log('didVerify', response);
         this.verifyToken = response;
      },
      onSubmit: function () {
         if (!this.verifyToken) {
            console.log('not verified!');
            return;
         } // this.$refs.recaptcha.execute();
         this.bodyText = this.bodyText.trim();
         console.log('delta', Date.now() - this.lastTimeSent);
         if (Date.now() - this.lastTimeSent < 60 * 1000) {
            this.tooSoon = true;
            return;
         }
         this.tooSoon = false;
         if (this.bodyText.length > 0) {
            this.lastTimeSent = Date.now();
            localStorage.lastTimeSent = this.lastTimeSent;
            this.feedbackSent = true;
            this.$apiPost('email', {text: this.bodyText, token: this.verifyToken});
         }
      },
   },
};
</script>



// WEBPACK FOOTER //
// src/components/FeedbackPage.vue